import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultAboutContent } from '../../siteContent';
import { useCms, Text, ImageField } from './cmsShared';

const AdminContentAbout = () => {
  const { content, update, uploadImage, save, saving } = useCms('about', defaultAboutContent);
  const c = content;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-xl font-bold text-[#003366]">About Page — Content</h2>
          <p className="text-sm text-gray-500">Edit the hero, mission blocks (with photos), leadership team and certifications.</p>
        </div>
        <Button onClick={save} disabled={saving} data-testid="cms-about-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>

      <Accordion type="multiple" defaultValue={['hero', 'mission']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-about-section-hero">Hero</AccordionTrigger>
          <AccordionContent>
            <Text label="Title" value={c.hero.title} onChange={(v) => update(['hero', 'title'], v)} testid="cms-about-hero-title" />
            <Text label="Subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="mission" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-about-section-mission">Mission Blocks (text & photos)</AccordionTrigger>
          <AccordionContent>
            {(c.mission || []).map((m, i) => (
              <div key={i} className="border rounded-lg p-3 mb-4 bg-gray-50">
                <Text label={`Block ${i + 1} title`} value={m.title} onChange={(v) => update(['mission', i, 'title'], v)} testid={`cms-about-mission-${i}-title`} />
                <Text label={`Block ${i + 1} description`} value={m.description} onChange={(v) => update(['mission', i, 'description'], v)} area />
                <ImageField label={`Block ${i + 1} photo`} value={m.image} onChange={(v) => update(['mission', i, 'image'], v)} onUpload={(f) => uploadImage(['mission', i, 'image'], f)} testid={`cms-about-mission-${i}-image`} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="team" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-about-section-team">Leadership Team</AccordionTrigger>
          <AccordionContent>
            <Text label="Section heading" value={c.team.heading} onChange={(v) => update(['team', 'heading'], v)} />
            <Text label="Section subtext" value={c.team.subtext} onChange={(v) => update(['team', 'subtext'], v)} area />
            {(c.team.members || []).map((mem, i) => (
              <div key={i} className="border rounded-lg p-3 mb-4 bg-gray-50">
                <div className="grid grid-cols-2 gap-2">
                  <Text label={`Member ${i + 1} name`} value={mem.name} onChange={(v) => update(['team', 'members', i, 'name'], v)} />
                  <Text label="Role" value={mem.role} onChange={(v) => update(['team', 'members', i, 'role'], v)} />
                </div>
                <Text label="Bio" value={mem.bio} onChange={(v) => update(['team', 'members', i, 'bio'], v)} area />
                <ImageField label="Photo" value={mem.image} onChange={(v) => update(['team', 'members', i, 'image'], v)} onUpload={(f) => uploadImage(['team', 'members', i, 'image'], f)} testid={`cms-about-team-${i}-image`} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="cert" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger>Certifications</AccordionTrigger>
          <AccordionContent>
            <Text label="Heading" value={c.certifications.heading} onChange={(v) => update(['certifications', 'heading'], v)} />
            {(c.certifications.items || []).map((it, i) => (
              <div key={i} className="grid grid-cols-2 gap-2 mb-2">
                <Text label={`#${i + 1} title`} value={it.title} onChange={(v) => update(['certifications', 'items', i, 'title'], v)} />
                <Text label="description" value={it.description} onChange={(v) => update(['certifications', 'items', i, 'description'], v)} />
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex justify-end mt-6">
        <Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>
    </div>
  );
};

export default AdminContentAbout;
